import React from 'react';
import { images } from 'assets/images/import-images';
import withContext from 'context/withContext';

type Props = {
  context: {
    loadingGlobal: {
      textLoading: string;
    };
  };
};

const LoaderAnimation: React.FC<Props> = props => {
  const {
    context: {
      loadingGlobal: { textLoading },
    },
  } = props;

  return (
    <div id="LoaderAnimation">
      <img className="loadingVoala" src={images.voalaLoading} alt="" />
      {textLoading && <div className="textLoading">{textLoading}</div>}
    </div>
  );
};

export default withContext(LoaderAnimation);
